import { PageHeader } from "../components/Layout";
import WheelView from "../components/WheelView";

export default function AttackWheel() {
  return (
    <div className="p-5 md:p-8 max-w-7xl mx-auto">
      <PageHeader title="Ruota Attacco" subtitle="Estrai un operatore di attacco. Solo gli operatori attivi entrano nell'estrazione." accent="blue" />
      <WheelView slug="attack" accentType="attack" />
    </div>
  );
}
